import { Flex, Box } from '@cad-arc';
import { UnitStatusSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormInput } from '../forms/integrated-form-controls/form-input';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { FormSection } from '../search-windows/form-section';
import { UnitStatusSearchFormType } from './types';
import {
    UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH,
    UNIT_SEARCH_FORM_INPUT_WIDTH,
} from '../search-windows/constants';

export function UnitStatusSearchFormEventRelatedSection({
    form,
    options,
}: {
    form: UseFormReturn<UnitStatusSearchFormType>;
    options: UnitStatusSearchOptions;
}) {
    return (
        <FormSection title="Event Related" width="100%">
            <Flex alignItems="flex-start" flexWrap="wrap" gap={4}>
                <Box
                    w={UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH}
                    minW={UNIT_SEARCH_FORM_INPUT_WIDTH}
                >
                    <FormInput name="eventNumber" label="CAD Event #" control={form.control} />
                </Box>
                <Box
                    w={UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH}
                    minW={UNIT_SEARCH_FORM_INPUT_WIDTH}
                >
                    <FormSelect
                        name="eventOrigins"
                        label="Call Origin"
                        control={form.control}
                        options={options.eventOriginOptions}
                        isMultiple={true}
                        truncateSelectedCount={3}
                    />
                </Box>
                <Box
                    w={UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH}
                    minW={UNIT_SEARCH_FORM_INPUT_WIDTH}
                >
                    <FormSelect
                        name="callForServices"
                        label="Calls For Service"
                        control={form.control}
                        options={options.callForServiceOptions}
                        isMultiple={true}
                        truncateSelectedCount={2}
                    />
                </Box>
                <Box
                    w={UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH}
                    minW={UNIT_SEARCH_FORM_INPUT_WIDTH}
                >
                    <FormSelect
                        name="priorities"
                        label="Priority"
                        control={form.control}
                        options={options.priorityOptions}
                        isMultiple={true}
                        truncateSelectedCount={2}
                    />
                </Box>
            </Flex>
        </FormSection>
    );
}
